<template>
  <div class="nd-container container-fluid">
    <div class="nd-main-panel">
      <div class="nd-main-panel-content container-fluid">
        <div class="nuxt-error">
          <component :is="errorPage" :error="error" />
          <div v-if="showDetails" class="error-debug mt-4 p-3 bg-light border rounded">
            <h5>Error Details</h5>
            <pre><code>{{ errorDisplay }}</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NotFoundError from '~/components/error/NotFoundError.vue';
import ServerError from '~/components/error/ServerError.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'nuxt-error',
  layout: 'error',
  props: {
    error: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    errorPage() {
      if (this.error.statusCode === 404) {
        return NotFoundError;
      }
      return ServerError;
    },
    errorDisplay() {
      return JSON.stringify({
        statusCode: this.error.statusCode,
        message: this.error.message,
        stack: this.error.stack
      }, null, 2);
    },
    showDetails() {
      return process.env.NODE_ENV !== 'production';
    }
  }
});
</script>
